/**
 * Main Layout
 *
 * Layout for application pages (My Quizzes, Journeys, Map, Stats, etc.).
 * Features: AppHeader (navigation) + PageHeader (title) + Content + Footer
 */

import { ReactNode } from "react";
import { AppHeader } from "./AppHeader";
import { PageHeader } from "./PageHeader";
import { Footer } from "./Footer";

interface MainLayoutProps {
  children: ReactNode;
  /**
   * Page title (H1)
   */
  title: string;
  /**
   * Optional subtitle/description
   */
  subtitle?: string;
  /**
   * Optional action buttons (e.g., "Create Quiz" button)
   */
  actions?: ReactNode;
}

export function MainLayout({
  children,
  title,
  subtitle,
  actions,
}: MainLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-[radial-gradient(circle_at_top,_rgba(72,118,255,0.12),transparent_55%)] bg-background">
      {/* Global Navigation */}
      <AppHeader />

      {/* Page Header */}
      <PageHeader title={title} subtitle={subtitle} actions={actions} />

      {/* Main content */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
